import { getAuthCode } from "./getAuthCode";

export const disconnectLinkedin = async (voiceId) => {
  try {
    const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/disconnectLinkedin", {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ auth_code: await getAuthCode(), voiceId })
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error disconnecting LinkedIn:", error);
    throw error;
  }
};
